import { fetchManager } from '../utils/fetchManager';

export const authService = {
  whoAmI: () => fetchManager('get', 'who-am-i'),
};
